import { Api } from 'utils';

class ServiceService {

	static admin = {
		get: async (params?: any) => Api.createResponse('admin/services',params),
		create: async (params?: any) => Api.createResponse('admin/services/create',params),
		edit: async (params?: any) => Api.createResponse('admin/services/edit',params),
		delete: async (params?: any) => Api.createResponse('admin/services/delete',params),
		getTypes: async (params?: any) => Api.createResponse('admin/services/types',params),
		getAreas: async (params?: any) => Api.createResponse('admin/services/areas',params),
	}

	static doctor = {
		get: async (params?: any) => Api.createResponse('doctor/services',params),
		getData: async (params?: any) => Api.createResponse('doctor/services/data',params),
		create: async (params?: any) => Api.createResponse('doctor/services/create',params),
		edit: async (params?: any) => Api.createResponse('doctor/services/edit',params),
		delete: async (params?: any) => Api.createResponse('doctor/services/delete',params),
		upload: async (params?: any) => Api.createResponse('doctor/services/upload',params),
		getServices: async (params?: any) => Api.createResponse('doctor/services/services',params),
		getSpecialities: async (params?: any) => Api.createResponse('doctor/services/specialities',params),
	}

	static clinic = {
		get: async (params?: any) => Api.createResponse('clinic/services',params),
		getData: async (params?: any) => Api.createResponse('clinic/services/data',params),
		create: async (params?: any) => Api.createResponse('clinic/services/create',params),
		edit: async (params?: any) => Api.createResponse('clinic/services/edit',params),
		delete: async (params?: any) => Api.createResponse('clinic/services/delete',params),
		upload: async (params?: any) => Api.createResponse('clinic/services/upload',params)
	}

}

export default ServiceService;